import { useQuery } from '@tanstack/react-query'
import { gql } from 'graphql-request'
import { gqlClient } from '@/lib/graphql'

export interface BookSummary {
  slug: string
  title: string
  author: string | null
  sourceLanguage: string
  targetLanguage: string
  status: string
  chaptersCount: number
}

const BOOKS = gql`
  query Books {
    books {
      slug
      title
      author
      sourceLanguage
      targetLanguage
      status
      chaptersCount
    }
  }
`

export function useBooks() {
  return useQuery({
    queryKey: ['books'],
    queryFn: async () => {
      const res = await gqlClient.request<{ books: BookSummary[] }>(BOOKS)
      return res.books
    },
    // Poll while anything is still ingesting.
    refetchInterval: (query) =>
      (query.state.data ?? []).some((b) => b.status === 'ingesting' || b.status === 'pending') ? 2000 : false,
  })
}
